import { CloseButton, Group, Paper } from '@mantine/core';

import OpportunityForm from '../../../../components/OpportunityForm';

import styles from './OpportunitiesFormMenu.module.scss';

interface Props {
  isOpen: boolean;
  oppOrRisk?: { id: string; netsuite_id: string; practitioner_id?: string; practitioner_name?: string; is_risk: boolean; };
  onSave: () => void;
  onClose: () => void;
}

const OpportunitiesFormMenu = ({ isOpen, oppOrRisk, onSave, onClose }: Props) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className={styles.overlay} />
      <Paper
        classNames={{
          root: styles.menu,
        }}
      >
        <Group gap={10} justify="flex-end">
          <CloseButton
            onClick={onClose}
          />
        </Group>
        <OpportunityForm
          action={oppOrRisk?.id}
          target={oppOrRisk?.is_risk ? "risk" : "opportunity"}
          onSave={onSave}
          currentPract={{
            netsuite_id: oppOrRisk?.netsuite_id || "",
            id: oppOrRisk?.practitioner_id ?? "",
            primary_name: oppOrRisk?.practitioner_name ?? "",
          }}
        />
      </Paper>
    </>
  );
}

export default OpportunitiesFormMenu;
